module.exports = __webpack_public_path__ + "img/plus-o.77a4e01f.svg";